import * as THREE from 'three';

/**
 * Creates a simple 3D golf ball model
 * Renders as a white sphere that animates along the shot trajectory
 */
export class GolfBall {
  private group: THREE.Group;
  private ball: THREE.Mesh;
  private rotationSpeed: number = 0.1;

  constructor() {
    this.group = new THREE.Group();
    this.ball = this.createGolfBall();
  }

  private createGolfBall(): THREE.Mesh {
    // Create golf ball sphere
    const ballGeometry = new THREE.SphereGeometry(3, 16, 16);
    const ballMaterial = new THREE.MeshStandardMaterial({
      color: 0xffffff, // White
      metalness: 0.1,
      roughness: 0.8,
    });
    const ball = new THREE.Mesh(ballGeometry, ballMaterial);

    this.group.add(ball);
    return ball;
  }

  /**
   * Get the THREE.Group containing the golf ball
   */
  public getGroup(): THREE.Group {
    return this.group;
  }

  /**
   * Update golf ball position
   */
  public setPosition(position: THREE.Vector3): void {
    this.group.position.copy(position);
  }

  /**
   * Update golf ball rotation to simulate spin along the trajectory
   */
  public setOrientation(_tangent: THREE.Vector3): void {
    // Rotate the ball continuously to simulate spin
    this.ball.rotation.x += this.rotationSpeed;
    this.ball.rotation.y += this.rotationSpeed * 0.7;
  }

  /**
   * Clean up resources
   */
  public dispose(): void {
    this.group.traverse((child) => {
      if (child instanceof THREE.Mesh) {
        child.geometry.dispose();
        if (child.material instanceof THREE.Material) {
          child.material.dispose();
        }
      }
    });
  }
}
